/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import { devLog } from '@/lib/logging';
import { Configuration, LogLevel } from '@azure/msal-browser';

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const loggerCallback = (
  level: LogLevel,
  message: string,
  containsPii: boolean
) => {
  if (containsPii) {
    return;
  }
  switch (level) {
    case LogLevel.Error:
      devLog(message);
      return;
    case LogLevel.Info:
      devLog(message);
      return;
    case LogLevel.Verbose:
      devLog(message);
      return;
    case LogLevel.Warning:
      devLog(message);
      return;
  }
};

export const configuration: Configuration = {
  auth: {
    clientId: 'f29f90b5-0b36-4f5f-a4c5-9809b92d15e7',
    authority: `https://cc521706-cf95-4c77-98a2-0262af23c5ed.ciamlogin.com/cc521706-cf95-4c77-98a2-0262af23c5ed/v2.0`,
    redirectUri: process.env.NEXT_PUBLIC_MSAL_REDIRECT_URI,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      loggerCallback,
      piiLoggingEnabled: true,
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const scopes = [
  'api://6690c775-9939-4398-8812-95be7c458dbf/Account.Read',
  'openid',
  'profile',
  'email',
];

export const authenticationRequest = {
  scopes,
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
//const silentRequest = {
//  scopes: ["openid", "profile"],
//  loginHint: "example@domain.net",
//};
//const idleTimerValue = 30000000;
//const remainingSessionTime = 6000000;

//export {
//  msalConfig,
//  loginRequest,
//  silentRequest,
//  idleTimerValue,
//  remainingSessionTime,
//};
